var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "final-docs__exempt" },
    [
      _vm.shouldShowExemptHint
        ? _c(
            "div",
            {
              staticClass: "final-docs__exempt-checkbox",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.openExemptModel.apply(null, arguments)
                },
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.pendingValue,
                    expression: "pendingValue",
                  },
                ],
                staticClass: "final-docs__cursor",
                class: { "not-allowed": _vm.isDisable },
                attrs: { type: "checkbox", disabled: _vm.isDisable },
                domProps: {
                  checked: Array.isArray(_vm.pendingValue)
                    ? _vm._i(_vm.pendingValue, null) > -1
                    : _vm.pendingValue,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.pendingValue,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.pendingValue = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.pendingValue = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.pendingValue = $$c
                    }
                  },
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldShowExemptHint
        ? _c("div", { staticClass: "final-docs__exempt-hint" }, [
            _c(
              "span",
              {
                class: _vm.hintClassName,
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.openExemptModel.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("tenantProjects.finalDocuments.exemptHint")) +
                    "\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("HKLModal", {
        ref: "exemptModalRef",
        attrs: {
          okBtnAction: "yesExempt",
          cancelBtnAction: "goback",
          title: _vm.$t("tenantProjects.finalDocuments.exemptModalHint"),
        },
        on: { onOkClick: _vm.exempt },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }